import { render, staticRenderFns } from "./MobilePage.vue?vue&type=template&id=78e62720&scoped=true"
import script from "./MobilePage.vue?vue&type=script&lang=js"
export * from "./MobilePage.vue?vue&type=script&lang=js"
import style0 from "./MobilePage.vue?vue&type=style&index=0&id=78e62720&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e62720",
  null
  
)

export default component.exports